import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'listsPageNoRefs',
  initialState: {
    contactStaticList: 0,
    contactDynamicList: 0,
    companyStaticList: 0,
    companyDynamicList: 0,
  },
  reducers: {
    setContactDynamicListPageNo: (state, action) => {
      state.contactDynamicList = action.payload;
    },
    setContactStaticListPageNo: (state, action) => {
      state.contactStaticList = action.payload;
    },
    setCompanyDynamicListPageNo: (state, action) => {
      state.companyDynamicList = action.payload;
    },
    setCompanyStaticListPageNo: (state, action) => {
      state.companyStaticList = action.payload;
    },
  },
});
export default slice.reducer;

export const listActions = { ...slice.actions };
